import React from 'react';
import { Create, SimpleForm } from 'react-admin';

import { CustomToolbar, Grid } from '../../components'
import AccessTerminalFields from './AccessTerminalFields'

export const AccessTerminalCreate = props => (
  <Create {...props}>
    <SimpleForm toolbar={<CustomToolbar />} redirect="list" >
      <Grid container spacing={8}>
        <AccessTerminalFields />
      </Grid>
    </SimpleForm>
  </Create>
);

export default AccessTerminalCreate
